import { render } from "./ConfidantPageFooter.vue?vue&type=template&id=bdff94b4&scoped=true"
import script from "./ConfidantPageFooter.vue?vue&type=script&lang=js"
export * from "./ConfidantPageFooter.vue?vue&type=script&lang=js"

import "./ConfidantPageFooter.vue?vue&type=style&index=0&id=bdff94b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdff94b4"]])

export default __exports__